var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"home"}},[_c('Search'),_c('Results')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }